class BridalShowcase extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.setupSwiperInstances();
  }

  setupSwiperInstances() {
    const swiperEls = this.querySelectorAll("swiper-container");
    swiperEls.forEach((swiperEl) => {
      const swiperNavNext = swiperEl.closest('[role="tabpanel"]').querySelector('button[data-direction="next"]');
      const swiperNavPrev = swiperEl.closest('[role="tabpanel"]').querySelector('button[data-direction="prev"]');
      const swiperPagination = swiperEl.closest('[role="tabpanel"]').querySelector(".swiper-pagination");
      const swiperParams = {
        slidesPerView: "auto",
        slidesPerGroup: 1,
        spaceBetween: 8,
        slidesOffsetBefore: 24,
        slidesOffsetAfter: 24,
        navigation: {
          nextEl: swiperNavNext,
          prevEl: swiperNavPrev,
        },
        pagination: {
          el: swiperPagination,
          type: "fraction",
        },
        simulateTouch: false,
        breakpoints: {
          750: {
            slidesOffsetBefore: 64,
            slidesOffsetAfter: 64,
            spaceBetween: 16,
          },
        },
        on: {
          init: () =>
            this.getAttribute("data-swiper-initialized", "false") &&
            this.setAttribute("data-swiper-initialized", "true"),
        },
      };

      Object.assign(swiperEl, swiperParams);
      swiperEl.initialize();
    });
  }
}

customElements.define("bridal-showcase", BridalShowcase);
